import { createSlice } from '@reduxjs/toolkit'
import baseReducers from 'apiV2/store/base/reducers'
import baseInitialState from 'apiV2/store/base/initialState'

import { indexCategories } from './asyncActions'

const categorySlice = createSlice({
  name: 'category',
  initialState: baseInitialState,
  reducers: baseReducers,
  extraReducers: {
    [indexCategories.fulfilled](state, action) {
      state.records = action.payload
    },
  },
})

export default categorySlice
